import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import TextArea from "../../../../../components/form/TextArea";

interface Props {
  maxLength?: number;
  tooltip?: string;
  placeholder?: string;
}

export default function AdditionalContextInput({
  maxLength = 500,
  tooltip = "Add any additional information about the source or channel which will be helpful to the AI for content generation.",
  placeholder = "example: Jane Doe is speaking in a podcast about the importance of mental health in fitness.",
}: Props) {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <TextArea
      label="Additional context"
      name="speakerAbout"
      value={values?.additionalContext ?? ""}
      tooltip={tooltip}
      placeholder={placeholder}
      maxLength={maxLength}
      maxHeight={150}
      showCharacterCount={true}
      onChange={({ target: { value } }) =>
        setFieldValue("additionalContext", value)
      }
      onBlur={({ target: { value } }) => {
        setFieldValue("additionalContext", value.trim());
      }}
    />
  );
}
